import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useCallback, useEffect, useRef, useState } from 'react';
import { createUseStyles, Input, Select } from '@Sage/hoi-poi-ui';
import { CHART_TYPES } from "../../../../constants";
import { useWeb5Context } from "../../../../../../lib/Web5Context";
import ChartSelector from "./fields/ChartSelector";
import SelectWithEntity from "./fields/SelectWithEntity";
import { getEntities } from "../../../../../../lib/services/forceBI";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Crud');
const defaultOptionsByField = {
  entity: []
};
const CrudFields = /*#__PURE__*/memo(_ref => {
  let {
    data,
    onChange,
    schema,
    errors
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const isFirstRender = useRef(true);
  const [optionsByField, setOptionsByField] = useState(defaultOptionsByField);
  const handleOnChange = useCallback(_ref2 => {
    let {
      fieldId,
      field
    } = _ref2;
    return value => {
      onChange && onChange({
        fieldId,
        value
      });
    };
  }, [onChange]);
  useEffect(() => {
    if (isFirstRender.current) {
      var _optionsByField$entit;
      isFirstRender.current = false;
      if (!(data !== null && data !== void 0 && data['chartType'])) {
        handleOnChange({
          fieldId: 'chartType'
        })(CHART_TYPES.bar);
      }
      if (!((_optionsByField$entit = optionsByField.entities) !== null && _optionsByField$entit !== void 0 && _optionsByField$entit.length)) {
        getEntities().then(entities => setOptionsByField(_objectSpread(_objectSpread({}, optionsByField), {}, {
          entity: entities
        })));
      }
    }
  }, [handleOnChange, t, data, optionsByField]);
  const getField = useCallback(field => {
    var _field$subFields, _data$field$parentId, _data$field$parentId2;
    const isReadOnly = field !== null && field !== void 0 && field.getIsReadOnly ? field.getIsReadOnly({
      fieldId: field.id,
      data
    }) : (field === null || field === void 0 ? void 0 : field.isReadOnly) || false;
    const isRequired = field !== null && field !== void 0 && field.getIsRequired ? field.getIsRequired({
      fieldId: field.id,
      data
    }) : (field === null || field === void 0 ? void 0 : field.isRequired) || false;
    const isHidden = field !== null && field !== void 0 && field.getIsHidden ? field.getIsHidden({
      fieldId: field.id,
      data
    }) : false;
    if (isHidden) return null;
    let fieldProps = {
      id: field.id,
      label: (field === null || field === void 0 ? void 0 : field.label) || ''
    };
    if (!(field !== null && field !== void 0 && (_field$subFields = field.subFields) !== null && _field$subFields !== void 0 && _field$subFields.length)) {
      fieldProps = _objectSpread(_objectSpread({}, fieldProps), {}, {
        isRequired: isRequired || false,
        isReadOnly: isReadOnly,
        placeholder: field === null || field === void 0 ? void 0 : field.placeholder,
        onChange: handleOnChange({
          fieldId: field.id,
          field
        }),
        isFullWidth: true,
        error: errors.includes(field.id) ? t('helptext_required_field') : '',
        hint: (field === null || field === void 0 ? void 0 : field.hint) || ''
      });
    } else {
      fieldProps = _objectSpread(_objectSpread(_objectSpread({}, fieldProps), field), {}, {
        onChange: handleOnChange,
        error: errors.includes(field.id) ? t('helptext_required_field') : ''
      });
    }
    if (field.shouldRenderField && !field.shouldRenderField({
      fieldId: field.id,
      data
    })) {
      return null;
    }
    switch (field === null || field === void 0 ? void 0 : field.type) {
      case 'chartSelector':
        return /*#__PURE__*/React.createElement(ChartSelector, _extends({
          key: field.id
        }, fieldProps, {
          value: (data === null || data === void 0 ? void 0 : data[field.id]) || '',
          data: data
        }));
      case 'text':
        return /*#__PURE__*/React.createElement(Input, _extends({
          key: field.id,
          label: field.label
        }, fieldProps, {
          value: (data === null || data === void 0 ? void 0 : data[field === null || field === void 0 ? void 0 : field.id]) || ''
        }));
      case 'singleValueList':
        if (field.options) fieldProps.options = field.options;else if (optionsByField[field.id]) {
          //to use preloaded options to reduce time of loading options
          fieldProps.options = optionsByField[field.id];
        }
        if (field.loadCustomOptions) {
          fieldProps.loadOptions = field.loadCustomOptions({
            data,
            t
          });
        } else if (field.parentId && data !== null && data !== void 0 && (_data$field$parentId = data[field.parentId]) !== null && _data$field$parentId !== void 0 && _data$field$parentId.value && field.loadOptions) {
          fieldProps.loadOptions = field.loadOptions(data[field.parentId].value.toLowerCase());
        } else if (field.loadOptions) {
          fieldProps.loadOptions = field.loadOptions;
        }
        if (typeof field.cacheOptions === 'boolean') {
          fieldProps.cacheOptions = field.cacheOptions;
        }
        return /*#__PURE__*/React.createElement(Select, _extends({
          key: field.id,
          label: field.label,
          placeholderReadOnly: field.placeholderReadOnly || ''
        }, fieldProps, {
          value: data === null || data === void 0 ? void 0 : data[field.id]
        }));
      case 'selectWithEntity':
        if (field.parentId && data !== null && data !== void 0 && (_data$field$parentId2 = data[field.parentId]) !== null && _data$field$parentId2 !== void 0 && _data$field$parentId2.value && field.loadOptions) {
          fieldProps.loadOptions = field.loadOptions(data[field.parentId].value.toLowerCase());
        }
        return /*#__PURE__*/React.createElement(SelectWithEntity, _extends({
          key: field.id
        }, fieldProps, {
          data: data,
          subFields: field.subFields
        }));
      default:
        return null;
    }
  }, [handleOnChange, data, errors, t, optionsByField]);
  const renderCrud = useMemo(() => {
    return schema.map((section, index) => {
      const fields = section.fields || [];
      return fields.map(field => {
        return getField(field);
      });
    });
  }, [schema, getField]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, renderCrud);
});
export default CrudFields;